
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Share = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g stroke="none" fill="none" className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M5.57608696,11.1651098 L5.57608696,20.6216316 C5.57608696,21.3016697 6.09291179,21.8609969 6.75520464,21.9282564 L6.88949275,21.9350374 L17.6105072,21.9350374 C18.2905454,21.9350374 18.8498726,21.4182125 18.9171321,20.7559197 L18.923913,20.6216316 L18.923913,11.1651098 L20.5,11.1651098 L20.5,20.6216316 C20.5,22.1583498 19.3003829,23.4148824 17.7865271,23.505851 L17.6105072,23.5111243 L6.88949275,23.5111243 C5.35277452,23.5111243 4.09624188,22.3115072 4.00527337,20.7976514 L4,20.6216316 L4,11.1651098 L5.57608696,11.1651098 Z M12.1987377,2 L17.7906055,6.94066321 L16.7002308,8.024223 L13.0710374,4.85665761 L13.0969464,16.3697368 L11.4613844,16.3697368 L11.4354754,4.85665761 L7.64542657,8.024223 L6.55505194,6.94066321 L12.1987377,2 Z"></path>
        </g>
      </g>
    </IconBase>);
};

Share.defaultProps = {
  title: 'Share',
};

export default Share;
